export enum DIALOGS {
  NEW_PROJECT = "newProject",
  CONFIRM = "confirm",
  UPLOAD_DATA = "uploadData",
  NEW_LAYER = "newLayer",
  NEW_LAYER_FROM_TABLE = "newLayerFromTable",
  ADD_TMS_SERVICE = "addTmsService",
  DELETE_RESOURCES = "deleteResources",
  EDIT_RESOURCE = "editResource",
  COPY_RESOURCE = "copyResource",
  COPY_CURRENT_PROJECT = "copyCurrentProject",
  COPY_LAYER_FROM_PROJECT = "copyLayerFromProject",
  BULK_COPY_RESOURCE = "bulkCopyResource",
  IMPORT = "import",
  EXPORT = "export",
  CONFIG_FILTER = "configFilter",
  CONFIG_LAYER = "configLayer",
  AVAILABILITY_AREA = "availabilityArea",
  BUFFER = "buffer",
  GEOMETRY_SELECTION = "geometrySelection",
  COPY_FEATURE = "copyFeature",
  DELETE_FEATURE = "deleteFeature",
  SHARE_DIALOG = "shareDialog",
  DELETE_LAYER = "deleteLayer",
  DELETE_GROUP = "deleteGroup",
  ADD_BOOKMARK = "addBookmarkDialog",
  INFO_RESOURCE = "infoResource",
  SIZE_RANGES = "sizeRangesDialog",
  CLASSES_RANGE_CALCULATION = "classesRangeCalculation",
  CLASSIFICATION_TITLE = "classificationTitle",
  SCALE_RESTRICTION = "scaleRestriction",
  AGGREGATION = "aggregation",
  LIMITS_EXCEEDED = "limitsExceeded",
  LAYER_FOLDER = "layerFolder",
  ADD_RELATED_LAYER = "addRelatedLayer",
  CLOSE_FEATURE_CARD = "closeFeatureCard",
  FEATURES_MULTI_EDIT = "featuresMultiEdit",
  ADD_IMAGE_ATTRIBUTE = "addImageAttribute",
  CALCULATED_ATTRIBUTES_VERTEX = "calculatedAttributesVertex",
  GROUND_INFO = "groundInfo",
  ADD_PROXY_SERVICE = "addProxyService",
  PROJECT_ACCESS = "projectAccess",
  LAYER_ACCESS = "layerAccess",
  TABLE_ACCESS = "tableAccess",
  WMS_LINK = "wmsLink",
  SCALE_SEGMENTATION = "scaleSegmentation",
  EDIT_COORDINATES = "editCoordinates",
  BASEMAP_SETTINGS = "basemapSettings",
  BASEMAP_ADD = "basemapAdd",
  TABLE_REFERENCES = "tableReferences",
  CLUSTER_SIZE_RANGES = "clusterSizeRangesDialog",
  PROJECTION_CHOICE = "projectionChoice",
  SELECT_RESOURCES = "selectResources",
  SELECT_FILES = "selectFiles",
  ADD_BY_LINK = "addByLink",
  SAVE_QLS_LAYER = "saveQLSLayer",
  PROJECT_INFO = "projectInfo",
  SAVE_TEMP_SOURCE_LAYER = "saveTempSourceLayer",
  SELECT_RESOURCE_PATH = "selectResourcePath",
}
